export const filterOperators = [
  { id: "is", label: "is", symbol: "=" },
  { id: "equals", label: "is equal to", symbol: "=" },
  { id: "not_equals", label: "is not equal to", symbol: "≠" },
  { id: "contains", label: "contains", symbol: "⊃" },
  { id: "does_not_contain", label: "does not contain", symbol: "⊅" },
  { id: "not_contains", label: "does not contain", symbol: "⊅" },
  { id: "starts_with", label: "starts with", symbol: "^" },
  { id: "ends_with", label: "ends with", symbol: "$" },
  { id: "greater_than", label: "greater than", symbol: ">" },
  { id: "less_than", label: "less than", symbol: "<" },
  { id: "greater_than_or_equal", label: "greater than or equal to", symbol: "≥" },
  { id: "less_than_or_equal", label: "less than or equal to", symbol: "≤" },
  { id: "before", label: "is before", symbol: "<" },
  { id: "after", label: "is after", symbol: ">" },
  { id: "on_or_before", label: "is on or before", symbol: "≤" },
  { id: "on_or_after", label: "is on or after", symbol: "≥" },
  { id: "contains_any", label: "contains any", symbol: "∈" },
  { id: "contains_all", label: "contains all", symbol: "⊆" },
  { id: "is_empty", label: "is empty", symbol: "∅" },
  { id: "is_not_empty", label: "is not empty", symbol: "∄" },
  { id: "exists", label: "exists", symbol: "✓" },
  { id: "between", label: "is between", symbol: "↔" },
  { id: "not_between", label: "is not between", symbol: "↮" },
  { id: "is_not", label: "is not", symbol: "≠" },
  // CRM Date-specific operators
  { id: "today", label: "Today", symbol: "📅" },
  { id: "yesterday", label: "Yesterday", symbol: "📅" },
  { id: "tomorrow", label: "Tomorrow", symbol: "📅" },
  { id: "this_week", label: "This Week", symbol: "📅" },
  { id: "last_week", label: "Last Week", symbol: "📅" },
  { id: "next_week", label: "Next Week", symbol: "📅" },
  { id: "this_month", label: "This Month", symbol: "📅" },
  { id: "last_month", label: "Last Month", symbol: "📅" },
  { id: "next_month", label: "Next Month", symbol: "📅" },
  { id: "this_quarter", label: "This Quarter", symbol: "📅" },
  { id: "last_quarter", label: "Last Quarter", symbol: "📅" },
  { id: "next_quarter", label: "Next Quarter", symbol: "📅" },
  { id: "this_year", label: "This Year", symbol: "📅" },
  { id: "last_year", label: "Last Year", symbol: "📅" },
  { id: "next_year", label: "Next Year", symbol: "📅" },
  { id: "last_7_days", label: "Last 7 Days", symbol: "📅" },
  { id: "last_30_days", label: "Last 30 Days", symbol: "📅" },
  { id: "last_60_days", label: "Last 60 Days", symbol: "📅" },
  { id: "last_90_days", label: "Last 90 Days", symbol: "📅" },
  { id: "next_7_days", label: "Next 7 Days", symbol: "📅" },
  { id: "next_30_days", label: "Next 30 Days", symbol: "📅" },
  { id: "next_60_days", label: "Next 60 Days", symbol: "📅" },
  { id: "next_90_days", label: "Next 90 Days", symbol: "📅" },
  { id: "custom_date", label: "Custom Date Range", symbol: "📅" },
];

export const operatorsByDataType = {
  text: [
    "equals",
    "not_equals",
    "contains",
    "does_not_contain",
    "starts_with",
    "ends_with",
    "is_empty",
    "is_not_empty",
  ],
  textarea: [
    "equals",
    "not_equals",
    "contains",
    "does_not_contain",
    "starts_with",
    "ends_with",
    "is_empty",
    "is_not_empty",
  ],
  rich_text: [
    "equals",
    "not_equals",
    "contains",
    "does_not_contain",
    "starts_with",
    "ends_with",
    "is_empty",
    "is_not_empty",
  ],
  email: [
    "equals",
    "not_equals",
    "contains",
    "does_not_contain",
    "starts_with",
    "ends_with",
    "is_empty",
    "is_not_empty",
  ],
  url: [
    "equals",
    "not_equals",
    "contains",
    "does_not_contain",
    "starts_with",
    "ends_with",
    "is_empty",
    "is_not_empty",
  ],
  domain: [
    "equals",
    "not_equals",
    "contains",
    "does_not_contain",
    "starts_with",
    "ends_with",
    "is_empty",
    "is_not_empty",
  ],
  phone_number: [
    "equals",
    "not_equals",
    "contains",
    "does_not_contain",
    "starts_with",
    "ends_with",
    "is_empty",
    "is_not_empty",
  ],
  number: [
    "equals",
    "not_equals",
    "greater_than",
    "less_than",
    "greater_than_or_equal",
    "less_than_or_equal",
    "between",
    "not_between",
    "is_empty",
    "is_not_empty",
  ],
  integer: [
    "equals",
    "not_equals",
    "greater_than",
    "less_than",
    "greater_than_or_equal",
    "less_than_or_equal",
    "between",
    "not_between",
    "is_empty",
    "is_not_empty",
  ],
  decimal: [
    "equals",
    "not_equals",
    "greater_than",
    "less_than",
    "greater_than_or_equal",
    "less_than_or_equal",
    "between",
    "not_between",
    "is_empty",
    "is_not_empty",
  ],
  currency: [
    "equals",
    "not_equals",
    "greater_than",
    "less_than",
    "greater_than_or_equal",
    "less_than_or_equal",
    "between",
    "not_between",
    "is_empty",
    "is_not_empty",
  ],
  date: [
    "is",
    "before",
    "after",
    "between",
    "not_between",
    "is_empty",
    "is_not_empty",
  ],
  datetime: [
    "is",
    "before",
    "after",
    "between",
    "not_between",
    "is_empty",
    "is_not_empty",
  ],
  crmDate: [
    "today",
    "yesterday",
    "tomorrow",
    "this_week",
    "last_week",
    "next_week",
    "this_month",
    "last_month",
    "next_month",
    "this_quarter",
    "last_quarter",
    "next_quarter",
    "this_year",
    "last_year",
    "next_year",
    "last_7_days",
    "last_30_days",
    "last_60_days",
    "last_90_days",
    "next_7_days",
    "next_30_days",
    "next_60_days",
    "next_90_days",
    "custom_date",
    "is_empty",
    "is_not_empty",
  ],
  boolean: ["is", "is_not", "is_empty", "is_not_empty"],
  select: [
    "is",
    "is_not",
    "is_empty",
    "is_not_empty",
  ],
  dropdown: [
    "is",
    "is_not",
    "is_empty",
    "is_not_empty",
  ],
  multi_select: [
    "contains",
    "does_not_contain",
    "contains_any",
    "contains_all",
    "is_empty",
    "is_not_empty",
  ],
  relation_record: [
    "contains",
    "not_contains",
    "contains_any",
    "contains_all",
    "is_empty",
    "is_not_empty",
  ],
  user: ["is", "is_not", "is_empty", "is_not_empty"],
  owner: ["is", "is_not", "is_empty", "is_not_empty"],
  id: ["equals", "not_equals", "exists"],
  select_timestamp: [
    "less_than",
    "between",
    "not_between",
    "after",
    "is_empty",
    "is_not_empty",
  ],
};

export const getOperatorsForDataType = (dataType) => {
  const normalizedType = (dataType || "text").toLowerCase();
  
  if (["date_time", "dateandtime", "date_and_time"].includes(normalizedType)) {
    return operatorsByDataType.datetime;
  }
  
  return operatorsByDataType[normalizedType] || operatorsByDataType.text;
};

export const getFilterOperatorOptions = (dataType) => {
  const allowedOperatorIds = getOperatorsForDataType(dataType);
  return filterOperators.filter((op) => allowedOperatorIds.includes(op.id));
};

export const operatorsWithoutValue = [
  "is_empty",
  "is_not_empty",
  "exists",
  // CRM Date operators that don't require additional value input
  "today",
  "yesterday",
  "tomorrow",
  "this_week",
  "last_week",
  "next_week",
  "this_month",
  "last_month",
  "next_month",
  "this_quarter",
  "last_quarter",
  "next_quarter",
  "this_year",
  "last_year",
  "next_year",
  "last_7_days",
  "last_30_days",
  "last_60_days",
  "last_90_days",
  "next_7_days",
  "next_30_days",
  "next_60_days",
  "next_90_days",
];

export const requiresValue = (operatorId) => {
  return !operatorsWithoutValue.includes(operatorId);
};

export const filterLogicOptions = [
  { id: "AND", label: "AND" },
  { id: "OR", label: "OR" },
];

